import { OnInit } from '@angular/core';
import { Severity } from '../../services/flash-messages/flash-message.model';
import { FlashMessagesService } from '../../services/flash-messages/flash-messages.service';
var FlashMessagesForComponent = /** @class */ (function () {
    function FlashMessagesForComponent(flashMessagesService) {
        this.flashMessagesService = flashMessagesService;
    }
    Object.defineProperty(FlashMessagesForComponent.prototype, "messages", {
        get: function () {
            return this.flashMessagesService.messagesFor(this.severity);
        },
        enumerable: true,
        configurable: true
    });
    FlashMessagesForComponent.prototype.close = function (id) {
        this.flashMessagesService.clear(id);
    };
    FlashMessagesForComponent.prototype.hasMessages = function () {
        return this.flashMessagesService.hasMessagesOf(this.severity);
    };
    FlashMessagesForComponent.prototype.ngOnInit = function () {
        if (this.context === 'danger') {
            this.severity = Severity.Danger;
        }
        else if (this.context === 'warning') {
            this.severity = Severity.Warning;
        }
        else if (this.context === 'success') {
            this.severity = Severity.Success;
        }
        else if (this.context === 'info') {
            this.severity = Severity.Info;
        }
        else {
            throw new Error('context must be one of "danger", "warning", "success" or "info"');
        }
    };
    return FlashMessagesForComponent;
}());
export { FlashMessagesForComponent };
